// extracted by mini-css-extract-plugin
module.exports = {"QuestionModule":"QuestionMode_QuestionModule__2nQu2","title-edit-container":"QuestionMode_title-edit-container__3VJpw"};